<template>
    <div class="containerImageCropper" @click.self="$emit('clickOutside')">
      
        <div class="imageCropper">

            <div class="containerMenuRatio hide-scrollbar">
                <div class="currentSize">
                    <div class="title">{{ $t('dash.post-creator.image-editor.resolution') }}</div>
                    <div class="inputs">
                        <input type="number" id="width" v-model="models.resolution.width" :placeholder="this.models.resolutionMax.width" :min="0" :max="this.models.resolutionMax.width" @keydown="onlyNumbers" @input="changeNumbers"/>
                        <span>x</span>
                        <input type="number" id="height" v-model="models.resolution.height" :placeholder="this.models.resolutionMax.height" :min="0" :max="this.models.resolutionMax.height" @keydown="onlyNumbers" @input="changeNumbers"/>
                    </div>
                </div>
                <div class="sectionNetwork" v-for="section in filteredMenuRatiosConfig">
                    <div class="title">{{ section.title }}</div>
                    <div class="items">
                        <div class="item" 
                            v-for="ratio in section.ratios" 
                            @click="toggleRatio(ratio.value, section.title)" 
                            :class="{'item--active': ratioSelected.network === section.title && ratioSelected.ratio === ratio.value && stencilProps.aspectRatio === ratio.value}"
                        >
                            <div class="containerRatio">
                                <div class="ratio" :style="{'aspect-ratio': ratio.value}">
                                    <p>{{ ratio.label }}</p>
                                </div>
                            </div>
                            <h5>{{ $t('dash.post-creator.image-editor.ratio-' + ratio.titleKey) }}</h5>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div class="editor">
                <div class="header-image-cropper">
                    <div class="NavSet" style="visibility: hidden;">
                        <button type="button" class="Button ButtonIconOnly" :title="$t('dash.post-creator.image-editor.undo')" @click="undo" :disabled="historyIndex <= 0">
                            <svg class="ButtonIcon" width="auto" height="auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" stroke-linecap="round" stroke-linejoin="round"><g><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M10 8h4c2.485 0 5 2 5 5s-2.515 5-5 5h-4"></path><path fill="currentColor" d="M5 8l4-3v6z"></path></g></g></svg>
                        </button>
                        <button type="button" class="Button ButtonIconOnly" :title="$t('dash.post-creator.image-editor.redo')" disabled="" @click="redo" :disabled="historyIndex >= history.length - 1">
                            <svg class="ButtonIcon" width="auto" height="auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" stroke-linecap="round" stroke-linejoin="round"><g><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M14 8h-4c-2.485 0-5 2-5 5s2.515 5 5 5h4"></path><path fill="currentColor" d="M19 8l-4-3v6z"></path></g></g></svg>
                        </button>
                    </div>
                    <div class="options">
                        <div class="option" @click="$refs.cropper.rotate(-90)">
                            <svg class="PinturaButtonIcon" width="auto" height="auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" stroke-linecap="round" stroke-linejoin="round"><g><g stroke="none" fill="currentColor"><path fill="none" d="M-1-1h582v402H-1z"></path><rect x="3" rx="1" height="12" width="12" y="9"></rect><path d="M15 5h-1a5 5 0 015 5 1 1 0 002 0 7 7 0 00-7-7h-1.374l.747-.747A1 1 0 0011.958.84L9.603 3.194a1 1 0 000 1.415l2.355 2.355a1 1 0 001.415-1.414l-.55-.55H15z"></path></g></g></svg>
                            {{ $t('dash.post-creator.image-editor.rotate-left') }}
                        </div>
                        <div class="option" @click="$refs.cropper.flip(true, false)">
                            <svg class="PinturaButtonIcon" width="auto" height="auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" stroke-linecap="round" stroke-linejoin="round"><g><g stroke="none" fill="currentColor"><path d="M11.93 7.007V20a1 1 0 0 1-1 1H5.78a1 1 0 0 1-.93-1.368l5.15-12.993a1 1 0 0 1 1.929.368z"></path><path d="M14 7.007V20a1 1 0 0 0 1 1h5.149a1 1 0 0 0 .93-1.368l-5.15-12.993A1 1 0 0 0 14 7.007z" opacity=".6"></path></g></g></svg>
                            {{ $t('dash.post-creator.image-editor.flip-horizontal') }}
                        </div>
                        <div
                            class="option"
                            v-if="mediaEditorEnabled"
                            @click="$emit('convert-to-video')"
                            :title="$t('dash.post-creator.image-editor.convert-to-video-hint')"
                        >
                            <i class="fa-solid fa-clapperboard"></i>
                            {{ $t('dash.post-creator.image-editor.convert-to-video') }}
                        </div>
                    </div>

                    <div class="btn-finish" @click="finish">
                        {{ $t('dash.post-creator.image-editor.finish') }}
                    </div>
                </div>

                <div class="containerVueCropper">
                    <div class="vueCropper">
                        <Cropper
                            ref="cropper"
                            :src="img.replace('s3-eu-west-1.amazonaws.com/saas.mashup', 'dd6kzhkw9q95q.cloudfront.net').replace('s3.eu-west-1.amazonaws.com/saas.mashup', 'dd6kzhkw9q95q.cloudfront.net')"
                            @ready="handleReady"
                            @change="change"
                            background-class="custom-background"
                            image-restriction="fit-area"
                            :stencil-props="stencilProps"
                            :default-size="defaultSize"
                            :crossOrigin="'anonymous'"
                        />
                    </div>
                </div>

                <div class="footer-image-cropper">
                </div>
            </div>
            <div class="ic-top-left">
                <div class="btn-reset" @click="reset" :class="{disabled: !isEdit}">
                    <svg class="ButtonIcon" width="auto" height="auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" stroke-linecap="round" stroke-linejoin="round"><g><g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" stroke-width=".125em"><path d="M7.388 18.538a8 8 0 10-2.992-9.03"></path><path fill="currentColor" d="M2.794 11.696L2.37 6.714l5.088 3.18z"></path><path d="M12 8v4M12 12l4 2"></path></g></g></svg>
                </div>
                <p class="ic-editor-title">
                    {{ $t('dash.post-creator.image-editor.title') }}
                    <span class="ic-beta-badge">({{ $t('dash.post-creator.image-editor.beta-badge') }})</span>
                </p>
            </div>
        </div>

    </div>
</template>



<script>
    import { Cropper } from 'vue-advanced-cropper';
    import 'vue-advanced-cropper/dist/style.css';

    export default {
        components: {
            Cropper,
        },
        props: {
            src: {
                type: String,
            },
            imageState: {
                type: Object,
                default: null,
            },
            allowedNetworks: {
                type: Array,
                default: null,
            },
            // Gates the "Créer une vidéo" option below - mirrors Form.vue's own isMediaEditorEnabled
            // gate on the video editor itself, so this bridge respects the same single toggle point.
            mediaEditorEnabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                img: this.src,

                stencilProps: {
                    handlersClasses: {
                        default: 'custom-handler',
                        eastNorth: 'custom-handler--corner',
                        westNorth: 'custom-handler--corner',
                        eastSouth: 'custom-handler--corner',
                        westSouth: 'custom-handler--corner',
                        // Cacher les handlers du milieu
                        north: 'custom-handler--hidden',
                        south: 'custom-handler--hidden',
                        east: 'custom-handler--hidden',
                        west: 'custom-handler--hidden',
                    },

                    linesClasses: {
                        default: 'custom-line',
                    }
                },

                menuRatiosConfig : [
                    {
                        title: 'google',
                        ratios : [
                            {
                                titleKey: 'landscape',
                                value: 16/9,
                                label: '16:9',
                            },
                            {
                                titleKey: 'square',
                                value: 1/1,
                                label: '1:1',
                            },
                        ]
                    },
                    {
                        title: 'instagram',
                        ratios : [
                            {
                                titleKey: 'square',
                                value: 1,
                                label: '1:1',
                            },
                            {
                                titleKey: 'landscape',
                                value: 16/9,
                                label: '16:9',
                            },
                            {
                                titleKey: 'portrait',
                                value: 4/5,
                                label: '4:5',
                            },
                            {
                                titleKey: 'feed',
                                value: 3/4,
                                label: '3:4',
                            },
                            {
                                titleKey: 'story',
                                value: 9/16,
                                label: '9:16',
                            },
                        ]
                    },
                    {
                        title: 'facebook',
                        ratios : [
                            {
                                titleKey: 'publication',
                                value: 16/9,
                                label: '16:9',
                            },
                            {
                                titleKey: 'highlighted-image',
                                value: 16/10,
                                label: '16:10',
                            },
                            {
                                titleKey: 'carousel',
                                value: 1/1,
                                label: '1:1',
                            },
                        ]
                    },
                    {
                        title: 'X',
                        ratios : [
                            {
                                titleKey: 'publication',
                                value: 2/1,
                                label: '2:1',
                            }
                        ]
                    },
                    {
                        title: 'Linkedin',
                        ratios : [
                            {
                                titleKey: 'publication',
                                value: 16/9,
                                label: '16:9',
                            }
                        ]
                    },
                    {
                        title: 'Pinterest',
                        ratios : [
                            {
                                titleKey: 'square',
                                value: 1/1,
                                label: '1:1',
                            },
                            {
                                titleKey: 'optimal',
                                value: 2/3,
                                label: '2:3',
                            },
                            {
                                titleKey: 'tall',
                                value: 12/1,
                                label: '12:1',
                            }
                        ]
                    },
                ],

                ratioSelected: {
                    network: null,
                    ratio: null,
                },

                isEdit:false,


                history: [],
                historyIndex: -1,
                isRestoring: true,
                timeoutIdChangeFunction: null,

                models: {
                    resolution : {
                        width:null,
                        height:null
                    },
                    resolutionMax: {
                        width:null,
                        height:null
                    },
                }

            };
        },
        computed: {
            filteredMenuRatiosConfig() {
                if (!this.allowedNetworks) {
                    return this.menuRatiosConfig;
                }
                return this.menuRatiosConfig
                    .filter(network => this.allowedNetworks.includes(network.title))
                    .sort((a, b) => {
                        return this.allowedNetworks.indexOf(a.title) - this.allowedNetworks.indexOf(b.title);
                    });
            }
        },
        methods: {

            handleReady() {
                console.log('handleReady')
                setTimeout(() => {
                    this.isRestoring = false;
                }, 50);

                
                const { image } = this.$refs.cropper.getResult();
                this.models.resolutionMax = {
                    width: image.width,
                    height: image.height,
                }
        
                if (!this.imageState) return;
 
                this.isEdit = true;

                this.$refs.cropper.$el.classList.add('no-transition');
                this.restoreState(this.imageState)
                setTimeout(() => this.$refs.cropper.$el.classList.remove('no-transition'), 50);
               
                
            },

            reset() {
               
                this.ratioSelected = {
                    network: null,
                    ratio: null,
                },
                this.stencilProps = {
                    ...this.stencilProps,
                    aspectRatio: null,
                };


                this.history = []
                this.historyIndex = -1
                this.isRestoring = false;

                this.$refs.cropper.reset()

                setTimeout(() => {
                    this.isEdit = false;
                }, 50);
            },

            
            defaultSize({ imageSize, visibleArea }) {
                return {
                    width: imageSize.width*1,
                    height: imageSize.height*1,
                };
            },

            toggleRatio(ratio, network) {
                this.$nextTick(() => {
                 
                    if (this.ratioSelected.network === network && this.ratioSelected.ratio === ratio) {
                        this.removeRatio()
                        return;
                    }

                    this.selectRatio(ratio, network);

                    
                })
            },

            removeRatio() {
                this.stencilProps = {
                    ...this.stencilProps,
                    aspectRatio: null,
                };
                this.ratioSelected = {
                    network: null,
                    ratio: null,
                }
            },

            selectRatio(ratio, network) {
                this.stencilProps = {
                    ...this.stencilProps,
                    aspectRatio: ratio,
                };

                this.ratioSelected = {
                    network,
                    ratio,
                }
        

                this.$nextTick(() => {
                    const { transforms } = this.$refs.cropper.getResult().image;
                    this.$refs.cropper.reset();
                    this.$refs.cropper.$el.classList.add('no-transition');
                    this.$nextTick(() => {
                        if (transforms.flip.horizontal) {
                            this.$refs.cropper.flip(true, false);
                        }
                        if (transforms.flip.vertical) {
                            this.$refs.cropper.flip(false, true);
                        }
                        if (transforms.rotate !== 0) {
                            this.$refs.cropper.rotate(transforms.rotate);
                        }
                        setTimeout(() => {
                            this.$refs.cropper.$el.classList.remove('no-transition');
                        }, 50);
                    });

                });
            },

    
            setSize(width, height) {
                this.$refs.cropper.setCoordinates(({ coordinates }) => ({
                    left: coordinates.left + (coordinates.width - width) / 2,
                    top: coordinates.top + (coordinates.height - height) / 2,
                    width,
                    height,
                }));
            },
        
            change({  coordinates, image }) {
                this.isEdit = true;
                this.models.resolution.width = Math.round(coordinates.width)
                this.models.resolution.height = Math.round(coordinates.height)
                return
                console.log('change', this.isRestoring)

               
                if (this.isRestoring) return;

                const state = { 
                    coordinates: { ...coordinates }, 
                    image: { ...image },
                    ratioSelected: { ...this.ratioSelected },
                };

                if (this.timeoutIdChangeFunction) {
                    if (this.timeoutIdChangeFunction) {
                        clearTimeout(this.timeoutIdChangeFunction);
                        this.timeoutIdChangeFunction = null;
                        this.history[this.history.length-1] = state;
                    }
                }else{
                    this.history = this.history.slice(0, this.historyIndex + 1);
                    this.history.push(state);
                    this.historyIndex++;
                };

        
                this.$nextTick(() => {
                    this.timeoutIdChangeFunction = setTimeout(() => {
                        this.timeoutIdChangeFunction = null;
                    }, 200);
                });

            },

            undo() {
                if (this.isRestoring) return;
                if (this.historyIndex <= 0) return;
                this.historyIndex--;

                if (this.history[this.historyIndex]) {
                    this.isRestoring = true;
                    this.$nextTick(() => {
                        const save = this.history[this.historyIndex];
                        console.log('undo', save)
                        if (save.ratioSelected) {
                            if (save.ratioSelected.ratio && save.ratioSelected.network) {
                                this.selectRatio(save.ratioSelected.ratio, save.ratioSelected.network);
                            }else{
                                this.removeRatio();
                            }
                        } 
                        this.$nextTick(() => {
                            this.restoreState(save);
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.isRestoring = false;
                                }, 500);
                            });
                        })
                    });
                   
                }
                
               
            },

            redo() {
                if (this.isRestoring) return;
                if (this.historyIndex >= this.history.length - 1) return;
                this.historyIndex++;
                if (this.history[this.historyIndex]) {
                    this.isRestoring = true;
                    this.$nextTick(() => {
                        const save = this.history[this.historyIndex];
                        if (save.ratioSelected) {
                            if (save.ratioSelected.ratio && save.ratioSelected.network) {
                                this.selectRatio(save.ratioSelected.ratio, save.ratioSelected.network);
                            }else{
                                this.removeRatio();
                            }
                        } 
              
                        this.$nextTick(() => {
                            this.restoreState(save);
                            this.$nextTick(() => {
                                setTimeout(() => {
                                    this.isRestoring = false;
                                }, 500);
                            });
                        });
                    });
                }
            },

            restoreState(state) {
              

                const { transforms } = state.image;

                if (transforms.flip.horizontal) {
                    this.$refs.cropper.flip(true, false);
                }
                if (transforms.flip.vertical) {
                    this.$refs.cropper.flip(false, true);
                }
                if (transforms.rotate) {
                    this.$refs.cropper.rotate(transforms.rotate);
                }

                this.$refs.cropper.setCoordinates(() => ({
                    ...state.coordinates,
                }));

               


            },

            async finish() {
                const { coordinates, canvas, image } = this.$refs.cropper.getResult();

                // Convertit le canvas en Blob
                const blob = await new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.9);
                });

                // Crée un File à partir du Blob
                const file = new File([blob], 'cropped-image.jpg', { type: 'image/jpeg' });

                this.$emit('finished', {
                    imageState: {
                        coordinates,
                        image,
                    },
                    dest: file,
                });
            },

            onlyNumbers(e) {
               
                const allowed = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab']
                if (!allowed.includes(e.key) && !/[\d,.]/.test(e.key)) {
                    e.preventDefault()
                    return
                }

            },
            
            changeNumbers(e) {
                console.log('changeNumbers', e.target.value)
                const input = e.target
                let val = parseFloat(input.value)
                if (isNaN(val)) return

                const min = parseFloat(input.min)
                const max = parseFloat(input.max)

                if (!isNaN(max)) val = Math.min(val, max)
                if (!isNaN(min)) val = Math.max(val, min)

                this.models.resolution[input.id] = val

                this.setSize(this.models.resolution.width, this.models.resolution.height)
            }
        },
    };
</script>

<style lang="scss" scoped>

</style>